import cn from 'classnames';

import styles from './form-section.module.scss';
import { forwardRef } from 'react';

export interface FormSectionProps {
  readonly title: string;
  readonly description?: React.ReactNode;
  readonly titlePlacement?: 'above' | 'side';
}

const FormSection = forwardRef(
  (
    {
      title,
      description,
      children,
      titlePlacement = 'above',
    }: React.PropsWithChildren<FormSectionProps> &
      React.HTMLAttributes<HTMLDivElement>,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <section
        ref={ref}
        className={cn(styles.container, {
          [styles.isTitleAbove]: titlePlacement === 'above',
          [styles.isTitleOnSide]: titlePlacement === 'side',
        })}
      >
        <div className={styles.info}>
          <h2 className={styles.title}>{title}</h2>
          {description ? (
            <p className={styles.description}>{description}</p>
          ) : null}
        </div>
        <div className={styles.content}>{children}</div>
      </section>
    );
  },
);

FormSection.displayName = 'FormSection';

export default FormSection;
